import { render, staticRenderFns } from "./emptyBox.vue?vue&type=template&id=40e27832"
import script from "./emptyBox.vue?vue&type=script&lang=js"
export * from "./emptyBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports